import React, { Component } from "react"
import axios from "axios"
import settings from "settings"
import { Formik, Field, Form } from "formik"
import transferFields from "models/transfer"
import DateField from "components/DateField"
import fieldStatus from "helpers/fieldStatus"
import * as Yup from "yup"
import submitData from "helpers/submitData"
import ReactSelect from "components/ReactSelect"
import TextArea from "components/TextArea"
import NumberField from "components/NumberField"
import Typeahead from "components/Typeahead"
import _ from "lodash"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "actions"
import { bindActionCreators } from "redux"
import cleanLeaveZero from "helpers/cleanLeaveZero"
import clone from "clone"
import matchModel from "helpers/matchModel"
import helpers from "helpers/helpers"
import currentUser from "helpers/currentUser"

class TransferModal extends Component {
	constructor(props) {
		super(props)
		this.state = {
			fields: transferFields,
			user: currentUser(),
			data: {
				address: "",
			},
		}
	}

	componentDidMount() {
		let userToken = localStorage.getItem("user")
		axios
			.post(settings.ep + "/allSaleInfo", this.props.data, {
				headers: { Authorization: `Bearer ${userToken}` },
			})
			.then((resp) => {
				let fields = clone(this.state.fields)
				let data = cleanLeaveZero(resp.data)
				data = matchModel(transferFields, data)
				let f = { ...fields, ...data }
				//f.floorplan = ''
				f.price = ""
				f.has_co = f.has_co == 1 ? true : false
				f = helpers.cleanZeroToNull(f)
				this.setState({
					fields: f,
				})
			})
	}

	validation = () => {
		if (this.props.super) {
			return Yup.object().shape({
				transfer_to_id: Yup.number().min(1, "Please choose an address from the list.").required("Required"),
				price: Yup.number()
					.min(100000, "Price must be at least $100,000.")
					.max(5000000, "Price must be below $5,000,000")
					.required("Required"),
				transfer_date: Yup.number().required("Required").typeError("Please enter a value."),
			})
		} else {
			return Yup.object().shape({
				transfer_reason: Yup.string().min(5, "Must be longer than 5 characters").required("Required"),
				transfer_to_id: Yup.number().min(1, "Please choose an address from the list.").required("Required"),
				transfer_date: Yup.number().required("Required").typeError("Please enter a value."),
				floorplan: Yup.number("Start typing to choose a floorplan from the list.")
					.positive("Start typing to choose a floorplan from the list.")
					.required("Start typing to choose a floorplan from the list.")
					.typeError("Please enter a value."),
				price: Yup.number()
					.min(100000, "Price must be at least $100,000.")
					.max(5000000, "Price must be below $5,000,000")
					.required("Required"),
				sqft: Yup.number()
					.min(500, "Square feet must be at least 500.")
					.max(25000, "Square feet maximum must be below 25,000")
					.required("Required")
					.typeError("Please enter a value."),
				primary_first: Yup.string().min(2, "Must be longer than 2 characters").required("Required"),
				primary_last: Yup.string().min(2, "Must be longer than 2 characters").required("Required"),
				has_co: Yup.boolean(),
				co_first: Yup.string().when("has_co", {
					is: true,
					then: Yup.string().min(2, "Must be longer than 2 characters").required("Required"),
					otherwise: Yup.string().notRequired(),
				}),
				co_last: Yup.string().when("has_co", {
					is: true,
					then: Yup.string().min(2, "Must be longer than 2 characters").required("Required"),
					otherwise: Yup.string().notRequired(),
				}),
				realtor_involved: Yup.number().typeError("Please choose either Yes or No").required("Required"),
				realtor_office: Yup.number().when("realtor_involved", {
					is: "Yes",
					then: Yup.number().required("Required"),
					otherwise: Yup.number().notRequired(),
				}),
				realtor_phone: Yup.string().when("realtor_involved", {
					is: "Yes",
					then: Yup.string()
						.min(10, "Phone number must be 10 digits")
						.max(10, "Phone number must be 10 digits")
						.required("Required"),
					otherwise: Yup.string().notRequired(),
				}),
				realtor: Yup.number().when("realtor_involved", {
					is: "Yes",
					then: Yup.number().min(2, "Must be longer than 2 characters").required("Required"),
					otherwise: Yup.number().notRequired(),
				}),
				realtor_email: Yup.string().when("realtor_involved", {
					is: "Yes",
					then: Yup.string().email("Invalid email address").required("Required"),
					otherwise: Yup.string().notRequired(),
				}),
				sale_date: Yup.number().required("Required").typeError("Please enter a value."),
				estimated_closing: Yup.number().required("Required").typeError("Please enter a value."),
				garage: Yup.number().moreThan(0).required("Required").typeError("Please enter a value."),
				stories: Yup.number().moreThan(0).required("Required").typeError("Please enter a value."),
				beds: Yup.number().moreThan(0).required("Required").typeError("Please enter a value."),
				full_baths: Yup.number().moreThan(0).required("Required").typeError("Please enter a value."),
				half_baths: Yup.number().required("Required").typeError("Please enter a value."),
				elevation: Yup.string().required("Required").typeError("Please enter a value."),
			})
		}
	}

	submitClasses = (f) => {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f,
		})

		return submitClasses
	}

	realtorFields = (f) => {
		if (f.values.realtor_involved == 1) {
			return (
				<React.Fragment>
					<li className={fieldStatus("realtor", f)}>
						<label htmlFor="realtor">
							Realtor License Number<sup>*</sup>
						</label>
						{f.errors.realtor && f.touched.realtor && (
							<div className="form__message">{f.errors.realtor}</div>
						)}
						<NumberField
							name="realtor"
							type="text"
							className="form__input"
							onChange={f.setFieldValue}
							onBlur={f.setFieldTouched}
							touched={f.touched.realtor}
							error={f.errors.realtor}
							value={f.values.realtor}
						/>
					</li>
					<li className={fieldStatus("realtor_office", f)}>
						<label htmlFor="realtor_office">
							Brokerage License Number <sup>*</sup>
						</label>
						{f.errors.realtor_office && f.touched.realtor_office && (
							<div className="form__message">{f.errors.realtor_office}</div>
						)}
						<NumberField
							name="realtor_office"
							type="text"
							className="form__input"
							onChange={f.setFieldValue}
							onBlur={f.setFieldTouched}
							touched={f.touched.realtor_office}
							error={f.errors.realtor_office}
							value={f.values.realtor_office}
						/>
					</li>
				</React.Fragment>
			)
		}
	}

	trafficSources = () => {
		return _.map(this.props.payload.public.trafficSources, (v) => {
			return { value: v.id, label: v.name }
		})
	}

	coFields = (f) => {
		if (f.values.has_co) {
			return (
				<React.Fragment>
					<li className={fieldStatus("co_first", f)}>
						<label htmlFor="co_first">
							Co-Buyer First Name<sup>*</sup>
						</label>
						{f.errors.co_first && f.touched.co_first && (
							<div className="form__message">{f.errors.co_first}</div>
						)}
						{this.state.fields.co_first}
					</li>
					<li className={fieldStatus("co_last", f)}>
						<label htmlFor="co_last">
							Co-Buyer Last Name<sup>*</sup>
						</label>
						{f.errors.co_last && f.touched.co_last && (
							<div className="form__message">{f.errors.co_last}</div>
						)}
						{this.state.fields.co_last}
					</li>
				</React.Fragment>
			)
		}
	}

	setFloorplan = (f, lot) => {
		if (lot && lot !== -1) {
			axios.post(settings.ep + "/getLot", { id: lot }).then((resp) => {
				//console.log(resp)
				if (resp.status == 200 && resp.data.start_date) {
					let fp = _.find(this.props.payload.public.floorplans, { id: resp.data.floorplan })
					if (fp) {
						//console.log(fp)
						f.setFieldValue("floorplan", lot)
						f.setFieldValue("label_floorplan", fp.name)
					}
					f.setFieldValue("estimated_closing", null)
					f.setFieldValue("elevation", resp.data.elevation)
					f.setFieldValue("sqft", resp.data.sqft)
					f.setFieldValue("stories", resp.data.stories)
					f.setFieldValue("beds", resp.data.beds)
					f.setFieldValue("full_baths", resp.data.full_baths)
					f.setFieldValue("half_baths", resp.data.half_baths)
					f.setFieldValue("garage", resp.data.garage)
				} else {
					f.setFieldValue("floorplan", null)
					f.setFieldValue("label_floorplan", null)
					f.setFieldValue("estimated_closing", null)
					f.setFieldValue("elevation", "")
					f.setFieldValue("sqft", null)
					f.setFieldValue("stories", null)
					f.setFieldValue("beds", null)
					f.setFieldValue("full_baths", null)
					f.setFieldValue("half_baths", null)
					f.setFieldValue("garage", null)
				}
			})
		}
	}

	render() {
		let co
		if (this.state.fields.co_first) {
			co = ` & ${this.state.fields.co_first} ${this.state.fields.co_last}`
		}
		return (
			<div className="modal">
				<h3>
					Transfer: {this.props.data.address} | {this.state.fields.primary_first}{" "}
					{this.state.fields.primary_last}
					{co}
				</h3>
				<Formik
					initialValues={this.state.fields}
					validationSchema={this.validation}
					validateOnMount={true}
					enableReinitialize
					onSubmit={(values, { setSubmitting }) => {
						setSubmitting(true)
						values.sale_id = this.props.data.sale_id
						submitData("inputTransfer", values)
							.then((data) => {
								this.props.notify(data, this.props.name)
							})
							.catch((e) => {
								this.props.notify(e, this.props.name)
								setSubmitting(false)
							})
					}}
					render={(f) => (
						<div>
							{/* console.log(f) */}
							<Form>
								<ul className="modalForm__list">
									<li className={fieldStatus("transfer_reason", f)}>
										<label htmlFor="transfer_reason">
											Transfer Reason<sup>*</sup>
										</label>
										{f.errors.transfer_reason && f.touched.transfer_reason && (
											<div className="form__message">{f.errors.transfer_reason}</div>
										)}
										<TextArea
											name="transfer_reason"
											className="form__textarea"
											value={f.values.transfer_reason}
											onChange={f.setFieldValue}
											onBlur={f.setFieldTouched}
											touched={f.touched.transfer_reason}
											error={f.errors.transfer_reason}
										/>
									</li>
									<li className={fieldStatus("primary_first", f)}>
										<label htmlFor="primary_first">
											Buyer First Name<sup>*</sup>
										</label>
										{f.errors.primary_first && f.touched.primary_first && (
											<div className="form__message">{f.errors.primary_first}</div>
										)}
										{this.state.fields.primary_first}
									</li>
									<li className={fieldStatus("primary_last", f)}>
										<label htmlFor="primary_last">
											Buyer Last Name<sup>*</sup>
										</label>
										{f.errors.primary_last && f.touched.primary_last && (
											<div className="form__message">{f.errors.primary_last}</div>
										)}
										{this.state.fields.primary_last}
									</li>
									<li className={fieldStatus("transfer_to_id", f)}>
										<label htmlFor="transfer_to_id">Destination Address</label>
										{f.errors.transfer_to_id && f.touched.transfer_to_id && (
											<div className="form__message">{f.errors.transfer_to_id}</div>
										)}
										<Typeahead
											name="transfer_to_id"
											className="form__input"
											value={f.values.transfer_to_id.value}
											onChange={(name, val) => {
												f.setFieldValue(name, val)
												// Check if the new lot has a start and if so, apply the floorplan.  If not, make sure floorplan is not set.
												this.setFloorplan(f, val)
											}}
											onBlur={f.setFieldTouched}
											touched={f.touched.transfer_to_id}
											error={f.errors.transfer_to_id}
											placeholder={f.values.label_address}
											ep="/addressesAvailableToSell"
											extra={this.props.data}
											super={this.props.super}
										/>
									</li>
									{this.coFields(f)}
									<li className={fieldStatus("price", f)}>
										<label htmlFor="price">
											Contract Price <sup>*</sup>
										</label>
										{f.errors.price && f.touched.price && (
											<div className="form__message">{f.errors.price}</div>
										)}
										<NumberField
											name="price"
											type="text"
											className="form__input"
											onChange={f.setFieldValue}
											onBlur={f.setFieldTouched}
											touched={f.touched.price}
											error={f.errors.price}
											value={f.values.price}
											thousandSeparator={true}
											prefix="$"
										/>
									</li>
									<li className={fieldStatus("transfer_date", f)}>
										<label htmlFor="transfer_date">
											Transfer Date <sup>*</sup>
										</label>
										{f.errors.transfer_date && f.touched.transfer_date && (
											<div className="form__message">{f.errors.transfer_date}</div>
										)}
										<DateField
											name="transfer_date"
											className="form__textarea"
											value={f.values.transfer_date}
											onChange={f.setFieldValue}
											onBlur={f.setFieldTouched}
											touched={f.touched.transfer_date}
											error={f.errors.transfer_date}
											blockFuture={true}
										/>
									</li>
									<li className={fieldStatus("estimated_closing", f)}>
										<label htmlFor="estimated_closing">
											Estimated Closing <sup>*</sup>
										</label>
										{f.errors.estimated_closing && f.touched.estimated_closing && (
											<div className="form__message">{f.errors.estimated_closing}</div>
										)}
										<DateField
											name="estimated_closing"
											className="form__textarea"
											value={f.values.estimated_closing}
											onChange={f.setFieldValue}
											onBlur={f.setFieldTouched}
											touched={f.touched.estimated_closing}
											error={f.errors.estimated_closing}
										/>
									</li>
									{/* <li className={fieldStatus("event_id", f)}>
										<label htmlFor="event_id">Event</label>
										{f.errors.event_id && f.touched.event_id && (
											<div className="form__message">{f.errors.event_id}</div>
										)}
										<Typeahead
											name="event_id"
											className="form__input"
											value={f.values.event_id.value}
											onChange={f.setFieldValue}
											onBlur={f.setFieldTouched}
											touched={f.touched.event_id}
											error={f.errors.event_id}
											placeholder={f.values.label_address}
											ep="/typeaheadEvents"
										/>
									</li> */}
									<li className={fieldStatus("realtor_involved", f)}>
										<label htmlFor="realtor_involved">
											Realtor Involved? <sup>*</sup>
										</label>
										{f.errors.realtor_involved && f.touched.realtor_involved && (
											<div className="form__message">{f.errors.realtor_involved}</div>
										)}
										<ReactSelect
											name={`realtor_involved`}
											options={[
												{
													value: 0,
													label: "No",
												},
												{
													value: 1,
													label: "Yes",
												},
											]}
											value={f.values.realtor_involved}
											onBlur={f.setFieldTouched}
											onChange={f.setFieldValue}
										/>
									</li>
									{this.realtorFields(f)}
									<li className={fieldStatus("floorplan", f)}>
										<label htmlFor="floorplan">
											Floorplan <sup>*</sup>
										</label>
										{f.errors.floorplan && f.touched.floorplan && (
											<div className="form__message">{f.errors.floorplan}</div>
										)}
										<Typeahead
											name="floorplan"
											className="form__input"
											value={f.values.floorplan ? f.values.floorplan.value : null}
											onChange={f.setFieldValue}
											onBlur={f.setFieldTouched}
											touched={f.touched.floorplan}
											error={f.errors.floorplan}
											placeholder={f.values.label_floorplan}
											ep="/typeaheadFloorplans"
										/>
									</li>
									<li className={fieldStatus("elevation", f)}>
										<label htmlFor="elevation">
											Elevation<sup>*</sup>
										</label>
										{f.errors.elevation && f.touched.elevation && (
											<div className="form__message">{f.errors.elevation}</div>
										)}
										<Field name="elevation" type="text" className="form__input" />
									</li>
									<li className={fieldStatus("sqft", f)}>
										<label htmlFor="sqft">
											Square Feet<sup>*</sup>
										</label>
										{f.errors.sqft && f.touched.sqft && (
											<div className="form__message">{f.errors.sqft}</div>
										)}
										<NumberField
											name="sqft"
											type="text"
											className="form__input"
											onChange={f.setFieldValue}
											onBlur={f.setFieldTouched}
											touched={f.touched.sqft}
											error={f.errors.sqft}
											value={f.values.sqft}
											thousandSeparator={true}
										/>
									</li>
									<li className={fieldStatus("stories", f)}>
										<label htmlFor="stories">
											Stories<sup>*</sup>
										</label>
										{f.errors.stories && f.touched.stories && (
											<div className="form__message">{f.errors.stories}</div>
										)}
										<NumberField
											name="stories"
											type="text"
											className="form__input"
											onChange={f.setFieldValue}
											onBlur={f.setFieldTouched}
											touched={f.touched.stories}
											error={f.errors.stories}
											value={f.values.stories}
											thousandSeparator={true}
										/>
									</li>
									<li className={fieldStatus("beds", f)}>
										<label htmlFor="beds">
											Beds<sup>*</sup>
										</label>
										{f.errors.beds && f.touched.beds && (
											<div className="form__message">{f.errors.beds}</div>
										)}
										<NumberField
											name="beds"
											type="text"
											className="form__input"
											onChange={f.setFieldValue}
											onBlur={f.setFieldTouched}
											touched={f.touched.beds}
											error={f.errors.beds}
											value={f.values.beds}
											thousandSeparator={true}
										/>
									</li>
									<li className={fieldStatus("full_baths", f)}>
										<label htmlFor="full_baths">
											Full Baths<sup>*</sup>
										</label>
										{f.errors.full_baths && f.touched.full_baths && (
											<div className="form__message">{f.errors.full_baths}</div>
										)}
										<NumberField
											name="full_baths"
											type="text"
											className="form__input"
											onChange={f.setFieldValue}
											onBlur={f.setFieldTouched}
											touched={f.touched.full_baths}
											error={f.errors.full_baths}
											value={f.values.full_baths}
											thousandSeparator={true}
										/>
									</li>
									<li className={fieldStatus("half_baths", f)}>
										<label htmlFor="half_baths">
											Half Baths<sup>*</sup>
										</label>
										{f.errors.half_baths && f.touched.half_baths && (
											<div className="form__message">{f.errors.half_baths}</div>
										)}
										<NumberField
											name="half_baths"
											type="text"
											className="form__input"
											onChange={f.setFieldValue}
											onBlur={f.setFieldTouched}
											touched={f.touched.half_baths}
											error={f.errors.half_baths}
											value={f.values.half_baths}
											thousandSeparator={true}
										/>
									</li>
									<li className={fieldStatus("garage", f)}>
										<label htmlFor="garage">
											Garage<sup>*</sup>
										</label>
										{f.errors.garage && f.touched.garage && (
											<div className="form__message">{f.errors.garage}</div>
										)}
										<NumberField
											name="garage"
											type="text"
											className="form__input"
											onChange={f.setFieldValue}
											onBlur={f.setFieldTouched}
											touched={f.touched.garage}
											error={f.errors.garage}
											value={f.values.garage}
											thousandSeparator={true}
										/>
									</li>
									{this.state?.user?.viewAs && (
										<li className={fieldStatus("comments", f)}>
											<label htmlFor="comments">Comments/Notes</label>
											{f.errors.comments && f.touched.comments && (
												<div className="form__message">{f.errors.comments}</div>
											)}
											<TextArea
												name="comments"
												className="form__textarea"
												value={f.values.comments}
												onChange={f.setFieldValue}
												onBlur={f.setFieldTouched}
												touched={f.touched.comments}
												error={f.errors.comments}
											/>
										</li>
									)}
								</ul>
								<input
									type="submit"
									value="Submit"
									className={this.submitClasses(f.isValid)}
									disabled={f.isSubmitting}
								/>
							</Form>
						</div>
					)}
				/>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		trafficSources: state.trafficSources,
		payload: state.payload,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getPayload,
			loadingStatus,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(TransferModal)
